
export default class Swipe {
    constructor(options) {
        this.threshold = 100;
        this.restraint = 100;
        this.timeout = 400;

        if(options) {
            Object.assign(this, options);
        }

        this.onLeft = () => {};
        this.onRight = () => {};
        this.onUp = () => {};
        this.onDown = () => {};

        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
    }

    attachListeners(node) {
        node.addEventListener('touchstart', this.onTouchStart, {passive: true});
        node.addEventListener('touchmove', this.onTouchMove, {passive: true});
        node.addEventListener('touchend', this.onTouchEnd, {passive: true});
    }

    detachListeners(node) {
        node.removeEventListener('touchstart', this.onTouchStart);
        node.removeEventListener('touchmove', this.onTouchMove);
        node.removeEventListener('touchend', this.onTouchEnd);
    }

    onTouchStart(e) {
        if(!e.changedTouches || !e.changedTouches.length) {
            return;
        }

        const touch = e.changedTouches[0];
        this.start = { x: touch.pageX, y: touch.pageY };
        this.startTime = new Date().getTime();
    }

    onTouchMove(e) {
    }

    onTouchEnd(e) {
        if(!this.start || !e.changedTouches || !e.changedTouches.length) {
            return;
        }

        const touch = e.changedTouches[0];
        const distance = { x: touch.pageX - this.start.x, y: touch.pageY - this.start.y };
        
        const elapsedTime = new Date().getTime() - this.startTime;

        
        if(elapsedTime <= this.timeout) {
            if(Math.abs(distance.x) >= this.threshold && Math.abs(distance.y) <= this.restraint) {
                if(distance.x < 0) {
                    this.onLeft();
                } else {
                    this.onRight();
                }
            } else if(Math.abs(distance.y) >= this.threshold && Math.abs(distance.x) <= this.restraint) {
                if(distance.y < 0) {
                    this.onUp();
                } else {
                    this.onDown();
                }
            }
        }
    }

    setOnLeft(fn) {
        this.onLeft = fn;
    }

    setOnRight(fn) {
        this.onRight = fn;
    }

    setOnUp(fn) {
        this.onUp = fn;
    }

    setOnDown(fn) {
        this.onDown = fn;
    }

    setThreshold(threshold) {
        this.threshold = threshold;
    }

}
